export const journalPoints = [
	{
		content: 'Как взять кредит под залог недвижимости. Плюсы и минусы',
		imageUrl: 'journal-item4.png',
		href: 'https://journal.credit.club/kak-vzyat-dengi-pod-zalog-nedvizhimosti',
	},
	{
		content: 'Залоговый кредит. Как это работает',
		imageUrl: 'journal-item5.png',
		href: 'https://journal.credit.club/kak-rabotaet-zalogovyj-kredit',
	},
	{
		content: 'Квартира в залоге. Что с ней теперь будет?',
		imageUrl: 'journal-item6.png',
		href: 'https://journal.credit.club/kvartira-v-zaloge',
	},
]
